import {QueryKeys} from '../../../queryDefaults/QueryKeys.ts';
import {useMutation} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {PatientsApi} from '../../../apis/PatientsApi/PatientsApi.ts';
import {IPatientsRegisterPayload} from '../Patient.ts';

export function usePostPatients() {

    return useMutation<number, AppMedError, IPatientsRegisterPayload>({
        mutationKey: [QueryKeys.patient, 'register'],
        mutationFn: async (variables: IPatientsRegisterPayload) => {
            const result = await PatientsApi.postPatient(variables);
            return result;
        },
    });
}
